import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTuiComponent } from './simple-icons-tui.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTuiComponent ],
    exports:      [ SimpleIconsTuiComponent ],
    bootstrap:    []
})
export class SimpleIconsTuiModule {}
